import React from "react";
import { useGlobalContext } from "../../utils/globalContext";
import TextSliderVertical from "./textSliderVertical";

const Subtitle = ({ content }) => {
  const { Trans } = useGlobalContext();
  return (
    <div id="subtitle">
      <hr />
      <div className="content">
        {content.subtitleContent && content.subtitleContent.length !== 0 ? (
          <div className="slider">
            <TextSliderVertical content={content.subtitleContent} />
          </div>
        ) : (
          <Trans>{content.text}</Trans>
        )}
      </div>
    </div>
  );
};

export default Subtitle;
